// queries/getTimeline.ts
import { TimelineItem } from '../types';

const staticTimeline: TimelineItem[] = [
  {
    timelineType: 'work',
    name: 'Linkfields Innovation',
    title: 'Software Developer',
    techStack: 'Remix, TypeScript, Node.js, Express.js, PostgreSQL, Prisma',
    summaryPoints: [
      'Built a UI component library with React and TypeScript, reducing code duplication by 40%',
      'Created a no-code action system for configurable API calls, downloads, and navigation',
      'Automated form filling using OpenAI Node.js Client, reducing manual effort by 50%',
      'Optimized REST APIs handling 10K+ daily requests with 20% faster response',
      'Implemented secure auth with JWT and OAuth, boosting login success by 35%'
    ],
    dateRange: 'Sep 2024 - Present'
  },
  {
    timelineType: 'work',
    name: 'Women\'s Safety Wing, Telangana Police',
    title: 'Web Developer Intern',
    techStack: 'React, Vite, Tailwind CSS, Firebase',
    summaryPoints: [
      'Built the CAP website serving 12,000+ students across Telangana',
      'Enhanced data visibility and UX through intuitive visualizations',
      'Boosted engagement and accessibility for government services'
    ],
    dateRange: 'Jun 2024 - Jul 2024'
  },
  {
    timelineType: 'work',
    name: 'NIST University',
    title: 'Software Developer Intern',
    techStack: 'Next.js, Firebase, Node.js, SMS API',
    summaryPoints: [
      'Developed a faculty dashboard for real-time management of 1,000+ student records',
      'Built Smart Attendance System with Firebase storage and automated SMS notifications',
      'Reduced manual entry errors by 40% and improved data processing speed by 30%',
      'Optimized UI/UX in collaboration with designers and IT administrators'
    ],
    dateRange: 'Jun 2024 - Aug 2024'
  },
  {
    timelineType: 'education',
    name: 'NIST University',
    title: 'Bachelor of Technology (B.Tech) in Computer Science',
    techStack: 'Data Structures, Full Stack Development, Cybersecurity, AI/ML',
    summaryPoints: [
      'Coursework: Data Structures, Cybersecurity, Data Science, AI, Machine Learning',
      'Gained expertise in Python, Java, C, SQL, and Web Development',
      'Engaged in hands-on projects applying AI/ML models and cybersecurity practices',
      'Implemented scalable solutions and secure applications'
    ],
    dateRange: 'Sep 2021 - Mar 2025'
  }
];

export async function getTimeline(): Promise<TimelineItem[]> {
  // Simulate async behavior
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticTimeline), 100);
  });
}
